<template>
  <div>
    <v-sheet id="contact" color="#BDBDBD" tag="section">
      <div class="py-12"></div>

      <h4 class="display-1 text-uppercase text-center text-white">
        Contact Us
      </h4>

      <p class="text-center text-white mx-16">
        Kindly Fill In This Form And A Consultant Will Get Back To You As Soon
        As Possible. A Consultant Will Try To Use Your Contact Number Or Email
        Address To Reach Out To You Withing 15 Minutes of Receiving Your
        Submission. Thank You For Your Cooperation
      </p>

      <v-theme-provider dark>
        <v-row class="mx-12">
          <v-col cols="12" class="mb-n8">
            <v-text-field
              :color="getThemeColor"
              flat
              :rules="nameRules"
              label="Name*"
              solo
              v-model="contactName"
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="mb-n8">
            <v-text-field
              flat
              :rules="emailRules"
              label="Email*"
              solo
              v-model="contactEmail"
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="mb-n8">
            <v-text-field
              flat
              label="Contact Number*"
              solo
              v-model="contactNumber"
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="mb-n8">
            <v-text-field
              flat
              :rules="nameRules"
              label="Subject*"
              solo
              v-model="contactSubject"
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="mb-n8">
            <v-textarea
              flat
              :rules="nameRules"
              label="Message*"
              solo
              v-model="contactBody"
            ></v-textarea>
          </v-col>

          <v-col class="mx-auto" cols="auto">
            <v-btn
              rounded
              large
              :style="getThemeStyle"
              x-large
              @click="submitContact()"
              elevation="24"
              >Submit</v-btn
            >
          </v-col>
        </v-row>
      </v-theme-provider>

      <div class="py-12"></div>
    </v-sheet>
  </div>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  computed: {
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getAppName() {
      return this.$store.getters.getAppName;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
  },
  data() {
    return {
      contactName: "",
      contactEmail: "",
      contactNumber: "",
      contactSubject: "",
      contactBody: "",
      nameRules: [(v) => !!v || "This Field is required"],
      emailRules: [
        (v) => !!v || "This Field is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
    };
  },
  methods: {
    submitContact() {
      if (
        this.contactName != "" &&
        this.contactEmail != "" &&
        this.contactNumber != "" &&
        this.contactSubject != "" &&
        this.contactBody != ""
      ) {
        this.$store.commit("setLoader", true);
        axios
          .postData("/submit-contact-form-to-company", {
            emis: this.getUserCompany.emis,
            name: this.contactName,
            email: this.contactEmail,
            phone: this.contactNumber,
            subject: this.contactSubject,
            body: this.contactBody,
          })
          .then((response) => {
            this.$store.commit("setLoader", false);
            if (response === "success") {
              this.$toast.success("Form Submitted Successfully!", {
                duration: 3000,
              });
            } else {
              this.$toast.error("Oops, Something Went Wrong!", {
                duration: 3000,
              });
            }
          });
      } else {
        this.$toast.error("All Contact Form Fields Are Required!", {
          duration: 3000,
        });
        alert("All Contact Form Fields Are Required!");
      }
    },
  },
};
</script>

<style></style>
